import { render, staticRenderFns } from "./VNav.vue?vue&type=template&id=2ee2a6e9&scoped=true"
import script from "./VNav.vue?vue&type=script&lang=js"
export * from "./VNav.vue?vue&type=script&lang=js"
import style0 from "./VNav.vue?vue&type=style&index=0&id=2ee2a6e9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee2a6e9",
  null
  
)

export default component.exports